<template>
  <v-app-bar
    app
    light
    color="white"
    elevation="0"
  >
    <div class="d-flex align-center">
    <v-btn
      @click="prevPage($router.go(-1))"
      href="#"
      class="ma-auto"
      text
      :width="10"
      rounded
    >
        <v-icon dark right class="m-0">
          mdi-arrow-left
        </v-icon>
    </v-btn>

    </div>

    <v-spacer></v-spacer>
    <v-spacer></v-spacer>

    <v-btn
      href="https://github.com/vuetifyjs/vuetify/releases/latest"
      target="_blank"
      text
    >
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name : 'NavigationTopBar',
  data () {
    return {
      logo : '@/assets/logo.png'
    }
  },
  methods : {
    prevPage (page) {
      this.$router.push(page)
    }
  }
}
</script>

<style>

</style>